document.addEventListener('DOMContentLoaded', () => {
  const stickyCart = document.querySelector('.cart-sticky'); 
  const triggerDivDesk = document.querySelector('.product-grid__container.grid'); 
  const triggerDivMob = document.querySelector('.product__main-photos'); 

  // Sticky bar logic
  if (window.innerWidth <= 768) {
    if (stickyCart && triggerDivMob) {
      const triggerOffset = triggerDivMob.offsetTop + triggerDivMob.offsetHeight - 200;
      const handleScroll = () => {
        if (window.scrollY > triggerOffset) {
          stickyCart.classList.add('stick');
        } else {
          stickyCart.classList.remove('stick');
        }
      };
      window.addEventListener('scroll', handleScroll);
    }
  } else {
    if (triggerDivDesk) {
      const handleScrollDesktop = () => {
        const triggerBottom = triggerDivDesk.getBoundingClientRect().bottom - 50;
        const windowHeight = window.innerHeight;
        if (triggerBottom <= windowHeight) {
          stickyCart.classList.add('stick');
        } else {
          stickyCart.classList.remove('stick');
        }
      };
      window.addEventListener('scroll', handleScrollDesktop);
    }
  }

  //INIT QUANTITY SELECTORS
  document.querySelectorAll('.js-qty').forEach(function(el) {
    new theme.QtySelector(el, {
      isCart: false
    });
  });

  //SYNC main and sticky input values
  const mainQtyInput = document.querySelector('.product__quantity .js-qty__num');
  const stickyQtyInput = document.querySelector('.cart-sticky .js-qty__num');

  if (mainQtyInput && stickyQtyInput) {
    mainQtyInput.addEventListener('change', function () {
      stickyQtyInput.value = this.value;
    });

    stickyQtyInput.addEventListener('change', function () {
      mainQtyInput.value = this.value;
    });
  }
});

// sync quantity
$(document).ready(function () {
  $(document).on('click', '.js-qty__adjust', function () {
    const input = $(this).siblings('.js-qty__num');
    let currentValue = input.val();
    // console.log('Quantity updated: ' + currentValue);
    $('.product__quantity .js-qty__num').val(currentValue);
  });
});